import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { ConversationUploadedFilesResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof ConversationUploadedFilesResponseDataSchema>>

type Params = {
  conversationId: string
  files: File[]
}

export function useUploadConversationMessageFilesMutation() {
  return useMutation({
    mutationFn: async ({ conversationId, files }: Params) => {
      const formData = new FormData()

      for (const file of files) {
        formData.append("file", file)
      }

      const { data } = await axios.post<Response>(
        `/conversations/${conversationId}/messages/files`,
        formData,
      )

      return data.data
    },
  })
}
